<app-vat-settings-card [vatRates]="(vatRates | async)!"></app-vat-settings-card>
